module.exports = __webpack_public_path__ + "img/mt5logo3.d1098b93.svg";